import { RouteObject } from 'react-router-dom';
import { lazy, Suspense } from 'react';

const NotificationsSettingsComponent = lazy(
  () => import('./notifications-settings.tsx')
);

export const notificationsSettingsRoutes: RouteObject[] = [
  {
    path: '',
    element: (
      <Suspense>
        <NotificationsSettingsComponent />
      </Suspense>
    )
  }
];
